import { Component, Input } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { TosTableTdComponent } from "../../tos-table/tos-table-td/tos-table-td.component";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { ColumnDto, EditableConfig, TableDataType } from "../../../models/table-meta.interface";
import { TableMenuComponent } from "../../table-menu/table-menu.component";
import { NgClass, NgIf } from "@angular/common";
import { CommonUtils } from "../../../utils/common-utils";
import { AgGridDataTypes } from "../ag-grid-wrapper.component";
import { DynamicFromDataType } from "../../../constants/dynamic-from-data-type";
import { ToggleComponent } from "../../common/toggle/toggle.component";

@Component({
  selector: "app-grid-table-cell",
  standalone: true,
    imports: [TosTableTdComponent, TableMenuComponent, TableMenuComponent, NgIf, ToggleComponent, NgClass], // Add Angular Data Grid Component
  templateUrl: "./ag-grid-table-cell.component.html",
    styleUrls: ["./ag-grid-table-cell.component.scss"],
})
export class AgGridTableCellComponent implements ICellRendererAngularComp {
  params: any;
  record!: any;
  colDef: ColDef | undefined;
  columnDto!: ColumnDto;
  readOnly: boolean = false;
  skipDotNotationLookup: boolean = false;
  protected displayValue: string = "";

  handleOptionSelected(record: any, actionName: any) {
    this.params.menuOptionSelected.emit({ record, actionName });
  }

  handleInlineAction(event: any) {
    this.params.actionClicked.emit(event);
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.record = params.data;
    this.colDef = params.colDef;
    this.columnDto = this.params.columnDto;
    this.readOnly = (params as any).readOnly ?? false;
    this.skipDotNotationLookup = (params as any).skipDotNotationLookup ?? false;
  }

    protected formatValue(columnDto: ColumnDto) {
        const rawValue = !this.skipDotNotationLookup ? CommonUtils.getNestedValue(this.record, columnDto?.fieldName) : this.record[columnDto?.fieldName];

        if (!CommonUtils.isNotNil(rawValue)) {
          return "";
        }

        if (!columnDto.editable) return rawValue;

        switch (columnDto.editableConfig?.inputType) {
            case DynamicFromDataType.PICKLIST:
                return this.formatPicklistData(rawValue, columnDto?.editableConfig);
            default:
                return rawValue;
        }
    }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.params = params;
    this.record = params.data;
    this.colDef = params.colDef;
    this.columnDto = this.params.columnDto;
    this.readOnly = (params as any).readOnly ?? false;
    this.skipDotNotationLookup = (params as any).skipDotNotationLookup ?? false;
    return true;
  }

  protected readonly AgGridDataTypes = AgGridDataTypes;
  protected readonly CommonUtils = CommonUtils;

  private formatPicklistData(rawValue: any, editableConfig: EditableConfig | undefined) {
    if (!editableConfig) {
      return rawValue;
    }

    const lookupDetails = editableConfig.lookupDetails;
    if (!lookupDetails) {
      return rawValue;
    }

    if (Array.isArray(rawValue)) {
      return rawValue
        .map(item => item?.[lookupDetails.bindLabel] ?? "")
        .filter(Boolean)
        .join(", ");
    } else if (typeof rawValue === "object" && rawValue !== null) {
      return rawValue[lookupDetails.bindLabel];
    }
    return rawValue;
  }

    updateBooleanValue(data: boolean) {
        if (this.readOnly) {
            return;
        }

        this.record[this.columnDto?.fieldName] = data;
        this.params.actionClicked.emit();
        console.log(this.record);
    }
}
